import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServicesDataConfiguration } from '../../data-config/service-data-config';

type GetInvoiceParams = {
  customer_number: string;
  invoice_number: string;
  start_date: string;
  end_date: string;
  pin: string;
  pin_search: string,
  imgPin: string;
  manifest: string;
  isDataCompleted: string;
  next_token: string;
};

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  constructor(private http: HttpClient) {}

  servicesDataConfiguration = new ServicesDataConfiguration();

  getInvoice({
    customer_number,
    invoice_number,
    start_date,
    end_date,
    pin,
    pin_search,
    imgPin,
    manifest,
    isDataCompleted,
    next_token
  }: GetInvoiceParams): Observable<any> {
    let params: string[] = [];
  
    function addParam(key: string, value: string | undefined, transform?: (val: string) => string) {
      if (value) {
        params.push(`${key}=${transform ? transform(value) : value}`);
      }
    }
  
    addParam('customer_number', customer_number, val => val.toUpperCase());
    addParam('invoice_number', invoice_number);
    addParam('start_date', start_date);
    addParam('end_date', end_date);
    addParam('pin', pin, val => val.toUpperCase());
    addParam('pin_search', pin_search);
    addParam('next_token', next_token);
    if (imgPin && isDataCompleted) {
      const value = isDataCompleted === '1' ? 'yes' : 'No';
      params.push(`is_otb=yes&dc=${value}&pin=${imgPin}`);
    }
  
    if (manifest && isDataCompleted) {
      const value = isDataCompleted === '1' ? 'yes' : 'No';
      params.push(`is_otb=yes&dc=${value}&manifest=${manifest.toUpperCase()}`);
    }
  
    const paramString = params.join('&');
    const s_url = `${this.servicesDataConfiguration.getInvoice}${paramString ? `?${paramString}` : ''}`;
  
    return this.http.get(window.location.href.replace('/web/index.html', '') + s_url, {
      responseType: 'text',
    });
  }  

  getPins(postData: any) {
    let s_url =
      this.servicesDataConfiguration.getPins +
      `?invoice_number=${postData.invoiceNumber}&customer_number=${postData.customerAccount}&start_date=${postData.invoiceDate}&end_date=${postData.invoiceDate}`;
    return this.http.get(window.location.href.replace('/web/index.html', '') + s_url, {
      responseType: 'text',
    });
  }
}
